module.exports = "/_next/static/images/c77896b35989e8105b3894671c4267fe-sec.gif.webp";